<template>
  <v-content class="grey lighten-3" fill-height>
    <div id="core-view">
      <div v-if="$store.state.alert.show" class="mx-4 mt-2">
        <alert></alert>
      </div>
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-content>
</template>

<script>
  import Alert from '../../components/helper/Alert';
  export default {    
    name: 'CoreView',
    components: {
      Alert
    }
    // metaInfo () {
    //   return {
    //     title: ''
    //   }
    // }
  }
</script>

<style>
  .container > .row {
    margin-left: 0px !important;
  }

  .container {
    padding: 0px;
  }
</style>